import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';

@Component({
  selector: 'storage',
  providers: [StorageService],
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements AfterViewInit, OnInit {

  storages: any[] = [];
  filteredStorages: any[];
  filterTitle: string;
  filterString: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Storage');
    //this.loadFilter('ALL', 'All parcels in storage');
    this.load();
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
    this.filterStorages(this.filterString.trim());
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  filterStorages(value: string = ''): void {
    this.filterString = value;
    if (this.filterString == '') {
      this.filteredStorages = this.storages.filter((storage: any) => {
        return (storage.containerName != null && storage.containerName.length != 0)});
    } else {
      this.filteredStorages = this.storages.filter((storage: any) => {
        return (storage.containerName != null && storage.containerName.length != 0 && storage.containerName.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
        (storage.storeUser != null && storage.storeUser.length != 0 && storage.storeUser.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
        (storage.reference != null && storage.reference.length != 0 && storage.reference.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
        (storage.workflowStatus != null && storage.workflowStatus.length != 0 && storage.workflowStatus.toLowerCase().indexOf(value.toLowerCase()) > -1);
      });
  }
  }


  async load(): Promise<void> {
    try {
      this._loadingService.register('storage.list');
      this.storages = await this._storageService.getContainerNameParcels('').toPromise();
      this.loadFilter('All parcels in storage');    
    } catch (error) {

    } finally {
     // this.filteredStorages = Object.assign([], this.storages);
      this._loadingService.resolve('storage.list');
    }
  }

  deleteContainerName(storage: any, eventType: string): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete the container name?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._deleteContainerName(storage, eventType);
        }
      });
  }

  private async _deleteContainerName(storage: any, eventType: string): Promise<void> {
    try {
      this._loadingService.register('storage.list');
      await this._storageService.updateStorageByBusinesskey(storage, eventType, storage.reference).toPromise();
      this.load();
      this._snackBarService.open('Container name deleted', 'Ok');
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the container name'});
    } finally {
      this._loadingService.resolve('storage.list');
    }
  }

  

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/storage/storage.component.ts